import { useState } from "react";
import TokenGrid from "./elements/TokenGrid";
import TokenList from "./elements/TokenList";
import equiv from "../../../../util/equiv";
import useNFTCollection from "../../../../hooks/ethereum/nft/useNFTCollection";
import useCatacombs from "../../../../hooks/ethereum/nft/skele/useCatacombs";
import getENV from "../../../../util/getENV";

const BATCH_SIZE = 21;
export default function Collection({ collection, wallet, mode, toggle, hide, labels, icons, statuses }) {
    //console.log('>>> Collection')
    const { modules } = getENV();
    const [loadAmt, setLoadAmt] = useState(BATCH_SIZE - 1);
    const { balance, tokenIDs } = collection?.tokensOfOwner(wallet, loadAmt);
    const isCatacombs = wallet == modules.catacombs.contract.address;
    const { catacombs } = useCatacombs()
    const [viewMode, setViewMode] = useState(mode || 'grid');
    const loadMore = () => {
        setLoadAmt(loadAmt + BATCH_SIZE);
    }
    const setGridView = () => {
        setViewMode('grid')
    };
    const setListView = () => {
        setViewMode('list')
    };
    if (hide > 0) {
        tokenIDs?.splice(tokenIDs?.indexOf(hide), 1);//remove hidden
    }
    const tokens = tokenIDs?.slice(0, loadAmt);// truncate to load amount
    const visibleBalance = balance - (hide > 0 ? 1 : 0);
    return (<>
        {tokenIDs?.length > 0 && toggle &&
            <div className="toggle">
                <div onClick={setGridView} className={`button ${equiv(viewMode, 'grid') ? 'active' : ''} w-button`}>grid</div>
                <div onClick={setListView} className={`button ${equiv(viewMode, 'list') ? 'active' : ''} w-button`}>list</div>
            </div>
        }
        {equiv(viewMode, 'grid') && <TokenGrid collection={isCatacombs ? catacombs : collection} tokenIDs={tokens} balance={visibleBalance} loadMore={loadMore} icons={icons} statuses={statuses} labels={labels} />}
        {equiv(viewMode, 'list') && <TokenList collection={isCatacombs ? catacombs : collection} tokenIDs={tokens} balance={visibleBalance} loadMore={loadMore} />}
    </>);
} 